(function () {
  'use strict';

  // Taal en markt-valuta uit de i18n-bridge (snippets/theme-i18n-strings.liquid).
  // Zonder bridge valt alles terug op de Nederlandse opmaak in euro's.
  var ADQ_LOCALE = (window.theme && window.theme.locale) || 'nl-NL';
  var ADQ_VALUTA = (window.theme && window.theme.currency) || 'EUR';

  // ============================================================
  // Helpers
  // ============================================================

  // Vertaalde strings uit de i18n-bridge (snippets/theme-i18n-strings.liquid).
  function tt(key, fallback) {
    return (window.theme && window.theme.t) ? window.theme.t(key, fallback) : fallback;
  }

  // Aanbevelingen via de locale-route (/de/recommendations/...), anders komen de
  // producttitels in het Nederlands terug.
  function recommendationsUrl() {
    if (window.theme && window.theme.routes && window.theme.routes.product_recommendations) {
      return window.theme.routes.product_recommendations;
    }
    return (window.theme && window.theme.url) ? window.theme.url('/recommendations/products') : '/recommendations/products';
  }

  function money(cents) {
    if (cents == null || isNaN(cents)) return '';
    // Eén geldopmaak voor de hele site: die van Shopify (shop.money_format),
    // zodat de drawer hetzelfde toont als de Liquid-prijzen ernaast.
    if (window.theme && window.theme.money) return window.theme.money(cents);
    var euros = cents / 100;
    try {
      return new Intl.NumberFormat(ADQ_LOCALE, {
        style: 'currency',
        currency: ADQ_VALUTA,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(euros);
    } catch (e) {
      return '€' + euros.toFixed(2).replace('.', ',');
    }
  }

  function debounce(fn, wait) {
    var timer = null;
    return function () {
      var ctx = this, args = arguments;
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function getCartMode() {
    return document.body.getAttribute('data-cart-mode') || 'b2c_drawer';
  }

  // ============================================================
  // Staffel (BSS quantity-break) — client-side preview voor de B2C-drawer.
  // Op /cart herschrijft de BSS-app de prijzen; in de drawer (eigen /cart.js
  // render) niet, dus passen we de korting hier zelf toe o.b.v.
  // window.BSS_B2B.qb.qbRules. De drawer matcht op dezelfde voorwaarden als BSS
  // (klant, uitgesloten klanten, collecties/tags, uitgesloten collecties): toont
  // hij staffel die BSS niet geeft, dan betaalt de klant in de checkout meer dan
  // hij hier zag (Compolux voor particulieren, 26-10-2026).
  // ============================================================
  function staffelCustomerTags() {
    var tags = (window.adeqoCustomer && window.adeqoCustomer.tags) || [];
    if (typeof tags === 'string') tags = tags.split(',');
    return tags.map(function (t) { return String(t).trim().toLowerCase(); }).filter(Boolean);
  }
  function staffelRules() {
    var qb = window.BSS_B2B && window.BSS_B2B.qb;
    return (qb && Array.isArray(qb.qbRules)) ? qb.qbRules : [];
  }
  function staffelList(value) {
    return String(value || '').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
  }

  // Collectie-id's en tags per product, uit sections/staffel-cart-data.liquid.
  var staffelProductData = {};
  function loadStaffelProductData(items) {
    var missing = (items || []).some(function (it) { return !staffelProductData[it.product_id]; });
    if (!missing) return Promise.resolve();
    var url = (window.theme && window.theme.url ? window.theme.url('/cart') : '/cart') + '?section_id=staffel-cart-data';
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-staffel-cart-data]');
        var data = el ? JSON.parse(el.textContent) : {};
        Object.keys(data).forEach(function (id) { staffelProductData[id] = data[id]; });
      })
      .catch(function () {});
  }

  // Productvoorwaarde van een regel: 0 = alle producten, 2 = collecties, 3 = tags
  // (zo staan ze in de live config); 1 = producten en 4 = varianten volgen uit de
  // veldnamen. Geeft null als het niet te beoordelen is.
  function staffelProductMatch(type, ids, collections, tags, variants, item) {
    type = parseInt(type, 10) || 0;
    if (type === 0) return true;
    if (type === 1) return staffelList(ids).indexOf(String(item.product_id)) !== -1;
    if (type === 4) return staffelList(variants).indexOf(String(item.variant_id)) !== -1;
    var data = staffelProductData[item.product_id];
    if (!data) return null;
    var own = (type === 2 ? data.c : type === 3 ? data.t : null);
    if (!own) return null;
    own = own.map(function (v) { return String(v).trim().toLowerCase(); });
    return staffelList(type === 2 ? collections : tags).some(function (v) { return own.indexOf(v) !== -1; });
  }

  // Wat niet te beoordelen is, telt als 'geldt niet': liever geen staffel tonen
  // dan een prijs die de checkout niet waarmaakt.
  function staffelRuleApplies(rule, item, customerTags) {
    if ((parseInt(rule.market_condition_type, 10) || 0) !== 0) return false;

    // Klant: 0 = iedereen, 4 = klanttags.
    var applyTo = parseInt(rule.apply_to, 10) || 0;
    if (applyTo === 4) {
      var required = staffelList(rule.customer_tags);
      if (!customerTags.some(function (t) { return required.indexOf(t) !== -1; })) return false;
    } else if (applyTo !== 0) {
      return false;
    }

    // Uitgesloten klanten: 1 = klanttags.
    var excludeFrom = parseInt(rule.exclude_from, 10) || 0;
    if (excludeFrom === 1) {
      var excluded = staffelList(rule.exc_customer_tags);
      if (customerTags.some(function (t) { return excluded.indexOf(t) !== -1; })) return false;
    } else if (excludeFrom !== 0) {
      return false;
    }

    if (staffelProductMatch(rule.product_condition_type, rule.product_ids, rule.product_collections,
        rule.product_tags, rule.product_variants, item) !== true) return false;

    if ((parseInt(rule.exc_product_type, 10) || 0) !== 0 &&
        staffelProductMatch(rule.exc_product_type, rule.exc_specific_products, rule.exc_product_collections,
          rule.exc_product_tags, rule.exc_product_variants, item) !== false) return false;

    return true;
  }
  function staffelActiveRule(item, customerTags) {
    var rules = staffelRules().filter(function (r) { return staffelRuleApplies(r, item, customerTags); });
    if (!rules.length) return null;
    rules.sort(function (a, b) { return (a.priority || 0) - (b.priority || 0); });
    return rules[0];
  }
  function staffelTierForQty(rule, qty) {
    if (!rule || !rule.qty_table) return null;
    for (var i = 0; i < rule.qty_table.length; i++) {
      var t = rule.qty_table[i];
      var to = (t.qty_to == null) ? Infinity : t.qty_to;
      if (qty >= t.qty_from && qty <= to) return t;
    }
    return null;
  }
  // Resultaat per cart-item (incl. BTW): { pct, lineCents, discountedLineCents, kortingCents }
  function staffelForItem(item, customerTags) {
    var qty = item.quantity || 0;
    var lineCents = item.final_line_price || 0;
    var base = { pct: 0, lineCents: lineCents, discountedLineCents: lineCents, kortingCents: 0 };
    if (!qty || !lineCents) return base;
    var rule = staffelActiveRule(item, customerTags);
    if (!rule) return base;
    var tier = staffelTierForQty(rule, qty);
    var pct = tier ? (parseFloat(tier.discount_value) || 0) : 0;
    if (pct <= 0) return base;
    var korting = Math.round(pct / 100 * lineCents);
    return { pct: pct, lineCents: lineCents, discountedLineCents: lineCents - korting, kortingCents: korting };
  }

  function fetchCart() {
    return fetch(window.theme && window.theme.url ? window.theme.url('/cart.js') : '/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function updateCartItem(lineKey, quantity) {
    return fetch(window.theme && window.theme.routes ? window.theme.routes.cart_change + '.js' : '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  function addToCart(items) {
    return fetch(window.theme && window.theme.routes ? window.theme.routes.cart_add + '.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); });
  }

  // Cross-sell config — match product op theme-settings tag-regel (window.adeqoCrossSell).
  // Theme settings regel: { match_tag, mode: 'fixed'|'per_panels', qty, unit_singular, unit_plural }
  function parseCrossSellConfig(product) {
    if (!product || !window.adeqoCrossSell || !window.adeqoCrossSell.length) return null;
    var tags = typeof product.tags === 'string'
      ? product.tags.split(',').map(function (t) { return t.trim().toLowerCase(); })
      : (product.tags || []).map(function (t) { return String(t).toLowerCase(); });

    for (var i = 0; i < window.adeqoCrossSell.length; i++) {
      var rule = window.adeqoCrossSell[i];
      if (!rule || !rule.match_tag) continue;
      if (tags.indexOf(String(rule.match_tag).toLowerCase()) === -1) continue;
      var unit = rule.unit_singular || 'stuks';
      var unitPlural = rule.unit_plural || (unit + 's');
      return {
        fixed_qty: rule.mode === 'fixed' ? (parseInt(rule.qty, 10) || 0) : 0,
        panels_per_unit: rule.mode === 'per_panels' ? (parseInt(rule.qty, 10) || 0) : 0,
        unit: unit,
        unit_plural: unitPlural,
        doel: tt('crosssell_target_plural', 'panelen')
      };
    }
    return null;
  }
  // Backwards-compat alias (oude naam wordt elders nog gebruikt)
  var parseCrossSellTags = parseCrossSellConfig;

  // Bouwt subtitle + aanbevolen quantity, in de taal van de bezoeker.
  // Fixed-qty: "<strong>2 eindlatten aanbevolen</strong>" (geen panelen-deling)
  // Proportioneel: "1 tube per 2 panelen · <strong>2 tubes aanbevolen</strong>"
  function recommendedText(count, unit) {
    return tt('crosssell_recommended', '{count} {unit} aanbevolen')
      .replace('{count}', count).replace('{unit}', unit);
  }
  function buildCrossSellSubtitle(conf, cartQty) {
    if (conf.fixed_qty && conf.fixed_qty > 0) {
      var unitLabelFixed = conf.fixed_qty === 1 ? conf.unit : conf.unit_plural;
      return {
        text: '<strong>' + recommendedText(conf.fixed_qty, unitLabelFixed) + '</strong>',
        quantity: conf.fixed_qty
      };
    }
    var aanbevolen = Math.max(1, Math.ceil(cartQty / conf.panels_per_unit));
    var unitLabel = aanbevolen === 1 ? conf.unit : conf.unit_plural;
    var ratio = tt('crosssell_ratio', '1 {unit} per {count} {target}')
      .replace('{unit}', conf.unit).replace('{count}', conf.panels_per_unit).replace('{target}', conf.doel);
    return {
      text: ratio + ' · <strong>' + recommendedText(aanbevolen, unitLabel) + '</strong>',
      quantity: aanbevolen
    };
  }

  function pulseCartIcon() {
    var icons = document.querySelectorAll('.header-adeqo__cart, .adeqo-search-drawer__cart');
    icons.forEach(function (el) {
      el.classList.remove('adeqo-cart-pulse');
      // Animatie herstarten zonder synchrone forced reflow (void el.offsetWidth):
      // dubbele rAF laat de class-removal eerst painten, dan opnieuw toevoegen.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { el.classList.add('adeqo-cart-pulse'); });
      });
    });
  }

  function updateCartBadges(count) {
    document.querySelectorAll('.header-adeqo__cart-badge, .adeqo-search-drawer__cart-badge, .adeqo-mobile-menu__header-cart-badge').forEach(function (el) {
      el.textContent = count;
      el.toggleAttribute('hidden', count === 0);
    });
  }

  // Inject pulse-animation styles eenmalig
  function injectPulseStyles() {
    if (document.getElementById('adeqo-cart-pulse-style')) return;
    var s = document.createElement('style');
    s.id = 'adeqo-cart-pulse-style';
    s.textContent =
      '@keyframes adeqoCartPulse{0%{transform:scale(1)}50%{transform:scale(1.15)}100%{transform:scale(1)}}' +
      '.adeqo-cart-pulse{animation:adeqoCartPulse .3s ease}';
    document.head.appendChild(s);
  }

  // ============================================================
  // BSS checkout-onderschepping in de drawer
  //
  // De BSS B2B-app past de staffelkorting alleen toe als ze de checkout-knop
  // onderschept: haar filter (custom:cart/checkout_ele) zet elke
  // <button name="checkout"> om naar een .bss-checkout-knop die de korting
  // toepast en daarna pas doorklikt naar de checkout. Op /cart doet BSS dit
  // automatisch; in deze custom drawer (op willekeurige pagina) moeten we de
  // scan expliciet triggeren via listenCartCheckout(). Idempotent — BSS slaat
  // al omgezette knoppen over — dus vaker roepen is veilig.
  // ============================================================
  function bssCheckoutReady() {
    var b = window.BSS_B2B;
    return !!(b && b.observer && b.observer.cartSubject &&
      typeof b.observer.cartSubject.listenCartCheckout === 'function');
  }
  function triggerBssCheckoutScan() {
    if (!bssCheckoutReady()) return false;
    try {
      var r = window.BSS_B2B.observer.cartSubject.listenCartCheckout();
      if (r && typeof r.catch === 'function') r.catch(function () {});
    } catch (e) { /* BSS-interne fout — de guard vangt de klik veilig op */ }
    return true;
  }
  // Poll kort tot BSS geladen is en zet dan de drawer-knop om. Wordt op page-load
  // én bij het openen van de drawer geroepen, zodat de knop ruim vóór een klik al
  // is omgezet.
  function ensureBssCheckout() {
    if (triggerBssCheckoutScan()) return;
    var n = 0;
    var iv = setInterval(function () {
      if (triggerBssCheckoutScan() || ++n >= 20) clearInterval(iv);
    }, 250);
  }
  // Veiligheidsnet: zolang BSS de drawer-knop NIET heeft omgezet (nog geen
  // .bss-checkout in de form) mag een ECHTE klik niet rechtstreeks naar de
  // volle-prijs-checkout submitten. Val dan terug op /cart, waar BSS de korting
  // alsnog toepast. BSS' eigen programmatische redirect-klik (isTrusted === false)
  // laten we altijd door — die komt ná het toepassen van de korting.
  function guardDrawerCheckout() {
    document.addEventListener('click', function (e) {
      if (!e.isTrusted) return;
      var btn = e.target && e.target.closest && e.target.closest('[data-cart-drawer-checkout]');
      if (!btn) return;
      var form = btn.closest('form');
      if (form && form.querySelector('.bss-checkout')) return; // BSS actief → laat door
      e.preventDefault();
      var fallback = document.querySelector('.adeqo-cart-drawer__btn--secondary');
      window.location.href = (fallback && fallback.getAttribute('href')) ||
        (window.theme && window.theme.routes ? window.theme.routes.cart : '/cart');
    }, true); // capture: vóór de native form-submit
  }

  // ============================================================
  // Cart Drawer (B2C)
  // ============================================================

  if (!customElements.get('cart-drawer-adeqo')) {
    class CartDrawer extends HTMLElement {
      constructor() {
        super();
        this.freeThreshold = parseInt(this.dataset.freeThreshold, 10) || 9800;
        // Composiet: eigen verzendprofiel (snippets/composiet-verzending.liquid).
        // Lege kosten = geen tarief naar het land van de bezoeker.
        this.composietThreshold = parseInt(this.dataset.composietThreshold, 10) || 150000;
        this.composietCost = parseInt(this.dataset.composietCost, 10);
        this.composietPakket = parseInt(this.dataset.composietPakket, 10) || 1000;
        // Duitsland: lagere vracht vanaf een trede (€79,95 vanaf €2.500).
        this.composietTredeVanaf = parseInt(this.dataset.composietTredeVanaf, 10);
        this.composietTredeCost = parseInt(this.dataset.composietTredeCost, 10);
        this.boundOnAdded = this.onCartAdded.bind(this);
        this.boundOnKeyDown = this.onKeyDown.bind(this);
        this.boundMouseMove = this.handleMouseMove.bind(this);
        this._applyMouseMove = this.applyMouseMove.bind(this);
        this._moveTicking = false;
        this.boundMouseLeave = this.handleMouseLeave.bind(this);
        this.panel = this.querySelector('.adeqo-cart-drawer__panel');
        this.closeFloat = this.querySelector('.adeqo-cart-drawer__close-floating');
        this.itemTemplate = this.querySelector('[data-cart-drawer-item-template]');
        this.crosssellTemplate = this.querySelector('[data-cart-drawer-crosssell-template]');
        this.itemsEl = this.querySelector('[data-cart-drawer-items]');
        this.emptyEl = this.querySelector('[data-cart-drawer-empty]');
        this.shippingEl = this.querySelector('[data-cart-drawer-shipping]');
        this.shippingFill = this.querySelector('[data-cart-drawer-shipping-fill]');
        this.shippingText = this.querySelector('[data-cart-drawer-shipping-text]');
        this.crosssellEl = this.querySelector('[data-cart-drawer-crosssell]');
        this.footerEl = this.querySelector('[data-cart-drawer-footer]');
        this.countEl = this.querySelector('[data-cart-drawer-count]');
        this.subtotalEl = this.querySelector('[data-cart-drawer-subtotal]');
      }

      handleMouseMove(e) {
        if (!this.panel || !this.closeFloat) return;
        // mousemove vuurt zeer vaak; throttle layout-read + style-write naar één
        // rAF per frame i.p.v. synchroon per event -> geen forced reflow.
        this._lastMouseX = e.clientX;
        this._lastMouseY = e.clientY;
        if (this._moveTicking) return;
        this._moveTicking = true;
        requestAnimationFrame(this._applyMouseMove);
      }

      applyMouseMove() {
        this._moveTicking = false;
        if (!this.panel || !this.closeFloat) return;
        var x = this._lastMouseX;
        var y = this._lastMouseY;
        var rect = this.panel.getBoundingClientRect();
        var outside = x < rect.left || x > rect.right ||
                      y < rect.top || y > rect.bottom;
        if (outside) {
          // De root heeft `zoom` (site 10% compacter op desktop). position:fixed
          // wordt door die zoom geschaald, terwijl clientX/Y in de visuele ruimte
          // zitten -> deel door de zoomfactor. De knop centreert zelf via
          // transform: translate(-50%,-50%), dus geen extra offset nodig.
          var zoom = parseFloat(getComputedStyle(document.documentElement).zoom) || 1;
          this.closeFloat.style.left = (x / zoom) + 'px';
          this.closeFloat.style.top = (y / zoom) + 'px';
          this.closeFloat.classList.add('is-visible');
        } else {
          this.closeFloat.classList.remove('is-visible');
        }
      }

      handleMouseLeave() {
        if (this.closeFloat) this.closeFloat.classList.remove('is-visible');
      }

      connectedCallback() {
        this.bindEvents();
        document.addEventListener('adeqo:cart:add', this.boundOnAdded);
      }

      disconnectedCallback() {
        document.removeEventListener('adeqo:cart:add', this.boundOnAdded);
        document.removeEventListener('keydown', this.boundOnKeyDown);
      }

      bindEvents() {
        // Close triggers
        this.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) {
          el.addEventListener('click', this.close.bind(this));
        }.bind(this));
      }

      onCartAdded() {
        if (getCartMode() !== 'b2c_drawer') return;
        this.refresh().then(this.open.bind(this));
      }

      onKeyDown(e) {
        if (e.key === 'Escape') this.close();
      }

      open() {
        // Sluit het account-modal als dat open staat — niet twee overlays tegelijk.
        if (typeof window.closeDesktopAccountModal === 'function') window.closeDesktopAccountModal();
        // Zorg dat BSS de afrekenknop heeft omgezet (staffelkorting) vóór de klant klikt.
        ensureBssCheckout();
        this.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', this.boundOnKeyDown);
        // Mouse tracking voor floating close button — alleen desktop
        if (window.innerWidth >= 768) {
          document.addEventListener('mousemove', this.boundMouseMove);
          document.addEventListener('mouseleave', this.boundMouseLeave);
        }
      }

      close() {
        this.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        document.removeEventListener('keydown', this.boundOnKeyDown);
        document.removeEventListener('mousemove', this.boundMouseMove);
        document.removeEventListener('mouseleave', this.boundMouseLeave);
        if (this.closeFloat) this.closeFloat.classList.remove('is-visible');
      }

      refresh() {
        var self = this;
        return fetchCart().then(function (cart) {
          return loadStaffelProductData(cart.items).then(function () {
            self.render(cart);
            updateCartBadges(cart.item_count);
            return cart;
          });
        });
      }

      render(cart) {
        if (!cart) return;
        this.countEl.textContent = cart.item_count;

        if (cart.item_count === 0) {
          this.emptyEl.hidden = false;
          this.itemsEl.hidden = true;
          this.itemsEl.innerHTML = '';
          this.shippingEl.hidden = true;
          this.crosssellEl.hidden = true;
          this.crosssellEl.innerHTML = '';
          this.footerEl.hidden = true;
          return;
        }

        this.emptyEl.hidden = true;
        this.itemsEl.hidden = false;
        this.footerEl.hidden = false;

        var tags = staffelCustomerTags();
        var discountedSubtotal = 0;
        cart.items.forEach(function (it) { discountedSubtotal += staffelForItem(it, tags).discountedLineCents; });

        this.renderItems(cart.items, tags);
        this.renderShipping(discountedSubtotal, cart.items);
        this.renderCrossSell(cart);

        this.subtotalEl.textContent = money(discountedSubtotal);

        // BSS-staffelregels laden async; als ze bij de eerste render nog niet
        // beschikbaar zijn, eenmalig kort opnieuw renderen zodra ze er zijn.
        if (staffelRules().length === 0 && !this._staffelRetry) {
          this._staffelRetry = true;
          var self = this, n = 0;
          var iv = setInterval(function () {
            if (staffelRules().length > 0) { clearInterval(iv); self.render(cart); }
            else if (++n >= 12) { clearInterval(iv); }
          }, 300);
        }
      }

      renderItems(items, customerTags) {
        customerTags = customerTags || staffelCustomerTags();
        this.itemsEl.innerHTML = '';
        items.forEach(function (item, idx) {
          var node = this.itemTemplate.content.cloneNode(true);
          var li = node.querySelector('li');
          li.setAttribute('data-line-key', item.key || (idx + 1));

          var img = node.querySelector('[data-item-image]');
          if (item.image) {
            img.src = item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x160$1$2');
            img.alt = item.title || item.product_title || '';
          }

          node.querySelectorAll('[data-item-link]').forEach(function (a) {
            a.href = item.url;
          });
          var titleEl = node.querySelector('.adeqo-cart-drawer__item-title');
          titleEl.textContent = item.product_title || item.title;

          var variantEl = node.querySelector('[data-item-variant]');
          if (item.variant_title && item.variant_title !== 'Default Title') {
            variantEl.textContent = item.variant_title;
          } else {
            variantEl.remove();
          }

          var staffel = staffelForItem(item, customerTags);
          node.querySelector('[data-item-price]').textContent = money(staffel.discountedLineCents);
          var oldEl = node.querySelector('[data-item-price-old]');
          var staffelEl = node.querySelector('[data-item-staffel]');
          if (staffel.pct > 0) {
            if (oldEl) { oldEl.textContent = money(staffel.lineCents); oldEl.hidden = false; }
            if (staffelEl) {
              staffelEl.innerHTML = tt('cart_tier_active', 'Staffel {pct}% actief').replace('{pct}', staffel.pct) + ' ' +
                '<span class="adeqo-cart-drawer__item-staffel-muted">· ' + tt('cart_discount', '{amount} korting').replace('{amount}', money(staffel.kortingCents)) + '</span>';
              staffelEl.hidden = false;
            }
          }

          var qtyInput = node.querySelector('[data-qty-input]');
          qtyInput.value = item.quantity;

          var lineKey = item.key || (idx + 1);

          var self = this;
          var debouncedUpdate = debounce(function (q) {
            self.changeQty(lineKey, q);
          }, 350);

          qtyInput.addEventListener('change', function () {
            debouncedUpdate(parseInt(qtyInput.value, 10) || 0);
          });
          qtyInput.addEventListener('input', function () {
            debouncedUpdate(parseInt(qtyInput.value, 10) || 0);
          });

          node.querySelector('[data-qty-decrease]').addEventListener('click', function () {
            var v = (parseInt(qtyInput.value, 10) || 1) - 1;
            qtyInput.value = Math.max(0, v);
            debouncedUpdate(Math.max(0, v));
          });
          node.querySelector('[data-qty-increase]').addEventListener('click', function () {
            var v = (parseInt(qtyInput.value, 10) || 0) + 1;
            qtyInput.value = v;
            debouncedUpdate(v);
          });
          node.querySelector('[data-qty-remove]').addEventListener('click', function () {
            self.changeQty(lineKey, 0);
          });

          this.itemsEl.appendChild(node);
        }, this);
      }

      changeQty(lineKey, quantity) {
        var self = this;
        return updateCartItem(lineKey, quantity).then(function () {
          self.refresh();
        });
      }

      renderShipping(totalPrice, items) {
        if (this.dataset.shippingPending) {
          this.shippingEl.classList.remove('adeqo-cart-drawer__shipping--reached');
          this.shippingFill.style.width = '0%';
          this.shippingText.textContent = this.dataset.shippingPending;
          this.shippingEl.hidden = false;
          return;
        }
        // Zit er composiet in de mand, dan geldt de composietdrempel (€1.500, DE €5.000) en
        // staan de verzendkosten erbij, want die zijn hoger dan de gebruikelijke €5,95.
        // Alles van Compolux zit in het composietprofiel. Tot de pakketgrens (stalen,
        // clips) gaat het als pakket onder de gewone €98; daarboven geldt de vracht.
        var composietItems = (items || []).filter(function (it) {
          return String(it.vendor || '').toLowerCase() === 'compolux';
        });
        var composietGram = composietItems.reduce(function (s, it) {
          return s + (it.grams || 0) * (it.quantity || 1);
        }, 0);
        if (composietItems.length && isNaN(this.composietCost)) {
          this.shippingEl.classList.remove('adeqo-cart-drawer__shipping--reached');
          this.shippingFill.style.width = '0%';
          this.shippingText.textContent = window.theme.t('cart_composiet_not_deliverable', 'Composiet gevelbekleding leveren wij alleen in Nederland, België en Duitsland.');
          this.shippingEl.hidden = false;
          return;
        }
        var composiet = composietGram > this.composietPakket;
        var drempel = composiet ? this.composietThreshold : this.freeThreshold;
        if (composiet && totalPrice < drempel) {
          var composietKosten = totalPrice >= this.composietTredeVanaf ? this.composietTredeCost : this.composietCost;
          this.shippingEl.classList.remove('adeqo-cart-drawer__shipping--reached');
          this.shippingFill.style.width = Math.min(100, Math.round((totalPrice / drempel) * 100)) + '%';
          this.shippingText.textContent = window.theme.t('cart_shipping_composiet', 'Verzending {cost}. Nog {amount} voor gratis verzending')
            .replace('{cost}', money(composietKosten))
            .replace('{amount}', money(drempel - totalPrice));
          this.shippingEl.hidden = false;
          return;
        }
        if (totalPrice >= drempel) {
          this.shippingEl.classList.add('adeqo-cart-drawer__shipping--reached');
          this.shippingFill.style.width = '100%';
          this.shippingText.textContent = window.theme.t('cart_free_shipping_added', '✓ Gratis verzending — toegevoegd');
        } else {
          this.shippingEl.classList.remove('adeqo-cart-drawer__shipping--reached');
          var pct = Math.min(100, Math.round((totalPrice / this.freeThreshold) * 100));
          this.shippingFill.style.width = pct + '%';
          var diff = this.freeThreshold - totalPrice;
          this.shippingText.textContent = window.theme.t('cart_shipping_remaining', 'Nog {amount} voor gratis verzending').replace('{amount}', money(diff));
        }
        this.shippingEl.hidden = false;
      }

      renderCrossSell(cart) {
        this.crosssellEl.innerHTML = '';
        this.crosssellEl.hidden = true;

        if (!cart.items || cart.items.length === 0) return;

        // Verzamel product IDs die al in cart zitten — om niet te dubbel suggereren
        var inCart = {};
        cart.items.forEach(function (i) { inCart[i.product_id] = true; });

        // Verzamel complementary recommendations voor ALLE cart-items, dedupe op product_id,
        // toon de eerste max 2 unieke aanbevelingen (bv. montagekit + eindlat in juiste kleur).
        // Volgorde van suggesties volgt de volgorde uit Shopify's Search & Discovery app
        // (complementary_products metafield per paneel-product).
        var self = this;
        var fetches = cart.items.map(function (item) {
          return fetch(recommendationsUrl() + '.json?product_id=' + item.product_id + '&intent=complementary&limit=4', { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.json() : null; })
            .catch(function () { return null; });
        });

        Promise.all(fetches).then(function (results) {
          var seen = {};
          var picks = [];
          results.forEach(function (data) {
            if (!data || !data.products) return;
            data.products.forEach(function (p) {
              if (window.theme.isGermanExcluded(p) || inCart[p.id] || seen[p.id]) return;
              seen[p.id] = true;
              picks.push(p);
            });
          });

          var toRender = picks.slice(0, 2);
          if (toRender.length === 0) return;

          // Totaal cart-qty als basis voor 'X aanbevolen' berekening.
          // Cross-sell tags worden NIET uitgesloten — als user later kit toevoegt
          // verandert berekening minimaal en blijft het overschat-veilig.
          var totalCartQty = cart.items.reduce(function (s, i) { return s + (i.quantity || 0); }, 0);

          // Eenmalige wrap + header bovenaan, daarna de cards
          var wrap = document.createElement('div');
          wrap.className = 'adeqo-cart-drawer__crosssell-wrap';
          wrap.innerHTML =
            '<div class="adeqo-cart-drawer__crosssell-header">' +
              '<span class="adeqo-cart-drawer__crosssell-header-line"></span>' +
              '<span class="adeqo-cart-drawer__crosssell-header-text">' + tt('cart_crosssell_header', 'Vergeet niet') + '</span>' +
              '<span class="adeqo-cart-drawer__crosssell-header-line"></span>' +
            '</div>';
          self.crosssellEl.appendChild(wrap);

          toRender.forEach(function (p) { self.renderCrossSellCard(p, wrap, totalCartQty); });
          self.crosssellEl.hidden = false;
        });
      }

      renderCrossSellCard(product, wrap, cartQty) {
        var node = this.crosssellTemplate.content.cloneNode(true);
        var firstVariant = product.variants && product.variants[0];
        if (!firstVariant) return;

        var img = node.querySelector('[data-cs-image]');
        var imgWrap = node.querySelector('[data-cs-image-wrap]');
        if (product.featured_image) {
          img.src = product.featured_image;
          img.alt = product.title;
        } else {
          imgWrap.remove();
        }

        node.querySelector('[data-cs-title]').textContent = product.title;

        // Resolution order:
        //   1. Dynamisch uit tags: 1-regel subtitle + aanbevolen quantity (drijft pill-prijs)
        //   2. Statische metafield custom.cross_sell_subtitle: alleen subtitle, qty = 1
        //   3. Geen subtitle, qty = 1
        var subtitleEl = node.querySelector('[data-cs-subtitle]');
        var addQty = 1;
        var conf = parseCrossSellTags(product);
        if (conf && cartQty && cartQty > 0) {
          var parts = buildCrossSellSubtitle(conf, cartQty);
          subtitleEl.innerHTML = parts.text;
          subtitleEl.hidden = false;
          addQty = parts.quantity;
        } else {
          var fallback = product.cross_sell_subtitle ||
            (product.metafields && product.metafields.custom && product.metafields.custom.cross_sell_subtitle);
          if (fallback) {
            subtitleEl.innerHTML = fallback;
            subtitleEl.hidden = false;
          }
        }

        var btn = node.querySelector('[data-cs-add]');
        var label = node.querySelector('[data-cs-add-label]');
        btn.setAttribute('data-cs-variant-id', firstVariant.id);
        btn.setAttribute('data-cs-quantity', addQty);
        var totalPrice = firstVariant.price * addQty;
        label.textContent = '+ ' + money(totalPrice);

        var self = this;
        btn.addEventListener('click', function () {
          btn.disabled = true;
          label.textContent = tt('cart_adding', 'Toevoegen…');
          addToCart([{ id: firstVariant.id, quantity: addQty }]).then(function () {
            self.refresh();
          }).catch(function () {
            btn.disabled = false;
            label.textContent = '+ ' + money(totalPrice);
          });
        });

        (wrap || this.crosssellEl).appendChild(node);
      }
    }

    customElements.define('cart-drawer-adeqo', CartDrawer);
  }

  // ============================================================
  // Cart Toast (B2B)
  // ============================================================

  // Pak het eerste line-item uit een /cart/add.js response (single OF wrapped {items: [...]}).
  function firstAddedItem(response) {
    if (!response) return {};
    if (response.items && response.items.length) return response.items[0];
    if (response.id) return response;
    return {};
  }

  function escapeHTML(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];
    });
  }


  if (!customElements.get('cart-toast-adeqo')) {
    class CartToast extends HTMLElement {
      constructor() {
        super();
        this.boundOnAdded = this.onCartAdded.bind(this);
        this.boundOnKeyDown = this.onKeyDown.bind(this);
        this.statusEl = this.querySelector('[data-toast-status]');
        this.titleEl = this.querySelector('[data-toast-title]');
        this.subtitleEl = this.querySelector('[data-toast-subtitle]');
        this.crosssellEl = this.querySelector('[data-modal-crosssell]');

        // Eenheid labels uit section settings (default panelen/paneel)
        this.unitSingular = this.dataset.unitSingular || 'paneel';
        this.unitPlural = this.dataset.unitPlural || 'panelen';
        this.statusLabel = this.dataset.statusLabel || 'Winkelwagen';
        this.itemSingular = this.dataset.itemSingular || 'item';
        this.itemPlural = this.dataset.itemPlural || 'items';
      }

      connectedCallback() {
        document.addEventListener('adeqo:cart:add', this.boundOnAdded);
        this.querySelectorAll('[data-toast-dismiss]').forEach(function (el) {
          el.addEventListener('click', this.hide.bind(this));
        }.bind(this));
      }

      disconnectedCallback() {
        document.removeEventListener('adeqo:cart:add', this.boundOnAdded);
        document.removeEventListener('keydown', this.boundOnKeyDown);
      }

      onCartAdded(e) {
        if (getCartMode() !== 'b2b_toast') return;

        var detail = (e && e.detail) || {};
        // Snelbestellen (B2B-portal) is een bulk-besteltool met eigen inline-
        // feedback + cart-badge. Geen onderbrekende modal/cross-sell daar.
        if (detail.source === 'b2b-quickorder') return;

        var requested = (detail.requested && detail.requested[0]) || {};
        var added = firstAddedItem(detail.response);
        var isSamples = detail.source === 'sample-configurator';

        // Refresh cart-state om totalen te tonen
        var self = this;
        fetchCart().then(function (cart) {
          updateCartBadges(cart.item_count);
          if (isSamples) {
            self.renderSamplesTitle(detail);
          } else {
            self.renderTitle(added, requested);
          }
          self.renderStatus(cart);
          // Bij stalen geen "Vergeet niet": de aanbeveling komt uit de hele winkelwagen
          // (bv. een paneel van eerder), dus naast een staal verschijnt dan een losse lat.
          self.renderCrossSell(cart, isSamples);
          self.show();
        });
      }

      // Stalen gaan in één keer in de winkelwagen, één regel per kleur. Eén staal:
      // gewoon de producttitel. Meer: "✓ 2 samples toegevoegd" met de kleuren eronder,
      // zonder het voorvoegsel dat ze allemaal delen ("Sample ").
      renderSamplesTitle(detail) {
        var count = (detail.requested || []).reduce(function (s, i) { return s + (i.quantity || 1); }, 0);
        var lines = (detail.response && detail.response.items) || [];
        var names = lines.map(function (l) { return l.product_title || l.title || ''; }).filter(Boolean);

        if (count <= 1 || names.length < 2) {
          this.titleEl.textContent = '✓ ' + (count || 1) + '× ' + (names[0] || 'Product');
          this.subtitleEl.hidden = true;
          return;
        }

        this.titleEl.textContent = '✓ ' + tt('cart_added_samples', '{count} samples toegevoegd').replace('{count}', count);
        var prefix = names[0].split(' ')[0] + ' ';
        var shared = names.every(function (n) { return n.indexOf(prefix) === 0 && n.length > prefix.length; });
        this.subtitleEl.textContent = names.map(function (n) { return shared ? n.slice(prefix.length) : n; }).join(', ');
        this.subtitleEl.hidden = false;
      }

      // Title = qty × volle product_title. Subtitle = variant_title alleen als
      // het zinvol is (niet 'Default Title' bij Adeqo's flat-product structuur).
      renderTitle(added, requested) {
        var name = added.product_title || added.title || requested.product_title || 'Product';
        var qty = added.quantity || requested.quantity || 1;
        this.titleEl.textContent = '✓ ' + qty + '× ' + name;

        var variant = added.variant_title || '';
        if (variant && variant !== 'Default Title') {
          this.subtitleEl.textContent = variant;
          this.subtitleEl.hidden = false;
        } else {
          this.subtitleEl.hidden = true;
        }
      }

      // Status: totaal items. GEEN prijs (BSS rewrited alleen op /cart pagina).
      // Eenheid 'panelen' alleen als ALLE cart-items panels zijn — anders 'items'
      // (mixed cart met montagekit/eindlat/sample). Adeqo products hebben leeg
      // product_type dus detectie gaat via product_title pattern "akoestische (wand)panelen" (NL) of "Akustikpaneel" (DE).
      renderStatus(cart) {
        var allPanels = (cart.items || []).length > 0 && cart.items.every(function (i) {
          var t = (i.product_title || i.title || '').toLowerCase();
          return /akoestische\s+(wand)?panelen|akustikpaneel/.test(t);
        });
        var label;
        if (allPanels) {
          label = cart.item_count === 1 ? this.unitSingular : this.unitPlural;
        } else {
          label = cart.item_count === 1 ? this.itemSingular : this.itemPlural;
        }
        this.statusEl.textContent = this.statusLabel + ': ' + cart.item_count + ' ' + label;
      }

      // Cross-sell: pak eerste complementary recommendation die NIET in cart zit.
      // Prominente variant — green-soft card met "VERGEET NIET" label en X-aanbevolen subtitle.
      // skip: alleen leegmaken (stalen toegevoegd).
      renderCrossSell(cart, skip) {
        if (!this.crosssellEl) return;
        this.crosssellEl.innerHTML = '';
        this.crosssellEl.hidden = true;

        if (skip || !cart.items || cart.items.length === 0) return;

        var inCart = {};
        cart.items.forEach(function (i) { inCart[i.product_id] = true; });

        var self = this;
        var fetches = cart.items.map(function (item) {
          return fetch(recommendationsUrl() + '.json?product_id=' + item.product_id + '&intent=complementary&limit=4', { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.json() : null; })
            .catch(function () { return null; });
        });

        Promise.all(fetches).then(function (results) {
          var seen = {};
          var pick = null;
          results.some(function (data) {
            if (!data || !data.products) return false;
            return data.products.some(function (p) {
              if (window.theme.isGermanExcluded(p) || inCart[p.id] || seen[p.id]) return false;
              seen[p.id] = true;
              pick = p;
              return true;
            });
          });
          if (!pick) return;

          var totalCartQty = cart.items.reduce(function (s, i) { return s + (i.quantity || 0); }, 0);
          self.renderCrossSellCard(pick, totalCartQty);
          self.crosssellEl.hidden = false;
        });
      }

      renderCrossSellCard(product, cartQty) {
        var firstVariant = product.variants && product.variants[0];
        if (!firstVariant) return;

        var addQty = 1;
        var subtitleHTML = '';
        var unitLabel = '';
        var conf = parseCrossSellTags(product);
        if (conf && cartQty > 0) {
          var parts = buildCrossSellSubtitle(conf, cartQty);
          subtitleHTML = parts.text;
          addQty = parts.quantity;
          unitLabel = addQty === 1 ? conf.unit : conf.unit_plural;
        } else if (product.cross_sell_subtitle) {
          subtitleHTML = product.cross_sell_subtitle;
        }

        // Button-label: GEEN prijs (BSS B2B rewrited prijzen alleen op /cart pagina —
        // Shopify variant.price is base prijs zonder staffel/BE BTW-vrijstelling).
        // Toon ipv prijs het aantal+eenheid zodat user weet wat ze toevoegen.
        var btnLabel = unitLabel
          ? '+ Voeg ' + addQty + ' ' + unitLabel + ' toe'
          : '+ Voeg toe';

        var imageHTML = product.featured_image
          ? '<img class="adeqo-cart-modal__cs-image" src="' + escapeHTML(product.featured_image) + '" alt="' + escapeHTML(product.title) + '" width="56" height="56" loading="lazy">'
          : '';
        var subtitleEl = subtitleHTML
          ? '<div class="adeqo-cart-modal__cs-subtitle">' + subtitleHTML + '</div>'
          : '';

        var card = document.createElement('div');
        card.className = 'adeqo-cart-modal__cs-card';
        card.innerHTML =
          '<div class="adeqo-cart-modal__cs-label">' + tt('cart_crosssell_header', 'Vergeet niet') + '</div>' +
          imageHTML +
          '<div class="adeqo-cart-modal__cs-info">' +
            '<div class="adeqo-cart-modal__cs-title">' + escapeHTML(product.title) + '</div>' +
            subtitleEl +
          '</div>' +
          '<button type="button" class="adeqo-cart-modal__cs-add">' + escapeHTML(btnLabel) + '</button>';

        var self = this;
        var btn = card.querySelector('.adeqo-cart-modal__cs-add');
        btn.addEventListener('click', function () {
          btn.disabled = true;
          var origText = btn.textContent;
          btn.textContent = tt('cart_adding', 'Toevoegen…');
          addToCart([{ id: firstVariant.id, quantity: addQty }]).then(function () {
            // Refresh modal-content na succesvolle add
            fetchCart().then(function (c) {
              updateCartBadges(c.item_count);
              self.renderStatus(c);
              self.renderCrossSell(c);
            });
          }).catch(function () {
            btn.disabled = false;
            btn.textContent = origText;
          });
        });

        this.crosssellEl.appendChild(card);
      }

      show() {
        this.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', this.boundOnKeyDown);

        // Focus default op "Doorgaan met winkelen" (workflow respect — user kan direct
        // doortikken met Enter zonder per ongeluk naar cart te gaan)
        var dismissBtn = this.querySelector('.adeqo-cart-modal__btn--secondary');
        if (dismissBtn) {
          setTimeout(function () { dismissBtn.focus({ preventScroll: true }); }, 200);
        }
      }

      hide() {
        this.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        document.removeEventListener('keydown', this.boundOnKeyDown);
      }

      onKeyDown(e) {
        if (e.key === 'Escape') this.hide();
      }
    }

    customElements.define('cart-toast-adeqo', CartToast);
  }

  // ============================================================
  // Header cart-icon — intercept B2C clicks to open drawer
  // ============================================================

  function bindCartIconClicks() {
    document.querySelectorAll('.header-adeqo__cart, .adeqo-search-drawer__cart').forEach(function (link) {
      if (link.dataset.cartDrawerBound) return;
      link.dataset.cartDrawerBound = '1';

      link.addEventListener('click', function (e) {
        if (getCartMode() !== 'b2c_drawer') return; // B2B navigeert gewoon naar /cart
        e.preventDefault();
        var drawer = document.querySelector('cart-drawer-adeqo');
        if (!drawer) {
          window.location.href = link.href;
          return;
        }
        drawer.refresh().then(function () { drawer.open(); });
      });
    });
  }

  // ============================================================
  // Init
  // ============================================================

  function init() {
    injectPulseStyles();
    bindCartIconClicks();
    guardDrawerCheckout();
    // Zet de afrekenknop al op page-load om (knop bestaat server-side, drawer dicht),
    // zodat hij ruim vóór interactie door BSS is omgezet naar de korting-knop.
    ensureBssCheckout();

    // Pulse cart icon on every successful add
    document.addEventListener('adeqo:cart:add', function () {
      pulseCartIcon();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
